import React from "react";
import { FormControlLabel, Switch } from "@mui/material";
import { styled } from "@mui/material";

const KMSwitch = (props) => {
    const { checked, disabled, label, onChange, value } = props;

    return (
        <FormControlLabel
            control={<IOSSwitch checked={checked} onChange={onChange} value={value} disabled={disabled} />}
            label={label}
        />
    );
};

const IOSSwitch = styled((props) => <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />)(
    ({ theme }) => ({
        width: 42,
        height: 26,
        padding: "2px",
        display: "flex",
        "&:active .MuiSwitch-thumb": {
            width: 22,
        },
        "& .MuiSwitch-switchBase": {
            padding: 2,
            "&.Mui-checked": {
                transform: "translateX(16px)",
                color: theme.palette.common.white,
                "& + .MuiSwitch-track": {
                    backgroundColor: "#2C99D2",
                    opacity: 1,
                    border: 0,
                },
            },
        },
        "& .MuiSwitch-thumb": {
            boxShadow: theme.shadows[1],
            width: "18px",
            height: "18px",
            borderRadius: 11,
            transition: theme.transitions.create(["width"], {
                duration: 200,
            }),
        },
        "& .MuiSwitch-track": {
            borderRadius: 13,
            width: "33px",
            height: "18px",
            backgroundColor: "#9e9e9e",
            opacity: 1,
            transition: theme.transitions.create(["background-color"]),
        },
    })
);

export default KMSwitch;
